const supportsSetCodecPreferences = window.RTCRtpTransceiver && "setCodecPreferences" in window.RTCRtpTransceiver.prototype;
export function getSupportedAudioCodecs() {
    const result = [];
    if (!supportsSetCodecPreferences)
        return result;
    const capabilities = RTCRtpSender.getCapabilities("audio");
    if (!capabilities)
        return result;
    const { codecs } = capabilities;
    for (const codec of codecs) {
        result.push(codec);
    }
    return result;
}
